<mdb-card cascade="true" narrower="true" [@fadeInOnEnter] >
  <div>
    <div class="special-color text-white d-flex justify-content-center p-3">
      <h5><i class="fa fa-search mr-1"></i>Search Asset</h5>
    </div>
    <kendo-grid
      class="mb-3"
      (selectionChange)="selectionChange($event)"
      [selectable]="{ checkboxOnly: false, mode: 'single' }"
      [pageSize]="'5'"
      [pageable]="false"
      [sortable]="true"
      [filterable]="true"
      [scrollable]="'none'"
      name="Asset"
      [appAMSBindingSearchAsset]="'AssetSearch'"
      [param1]="method"
    >
      <kendo-grid-checkbox-column [width]="70"></kendo-grid-checkbox-column>

      <kendo-grid-column media="md" class="no-padding" title="" field="description" filter="text">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex">
            <div class="avatar mx-5">
              <img style="height: 50px; width: 50px;" src="{{ dataItem.photo ? baseUrl + 'asset/photo/' + dataItem.assetCode + '/1' : '../assets/img/monitor_computer.jpg' }}" class="img-fluid z-depth-2" alt="avatar" />
            </div>
            <div class="text-wrap">
              <div class="text-wrap">{{ dataItem.description }}</div>
              <app-asset-status [status]="dataItem.status"></app-asset-status>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>
    </kendo-grid>
  </div>
</mdb-card>
